const Parabola01Icon = /*#__PURE__*/ [
  ["path", { d: "M21 3C21 11.2843 16.9706 18 12 18C7.02944 18 3 11.2843 3 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 21H4.05882M15.7059 21H16.7647M19.9412 21H21M7.23529 21H8.29412M11.4706 21H12.5294", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { Parabola01Icon as default };
//# sourceMappingURL=Parabola01Icon.js.map
